import { types } from '../actions/filtersOptionsFromApi';
import { TNE_SORT_BY } from '../utils/enums';

const initialState = {
  filters: {
    Locations: [],
    Years: [],
    Status: [],
    Contractors: [],
    ClaimNames: [],
    Months: []
  }
};

export default function reduce(state = initialState, action) {
  switch (action.type) {
    case types.GET_OPTIONS_FILTERS:
      return {
        ...state,
        filters: {
          ...action.payload,
          SortBy: [TNE_SORT_BY.PERIOD, TNE_SORT_BY.CHANGE]
        }
      };
    case types.GET_OPTIONS_FILTERS_FULFILLED:
      return {
        ...state,
        filters: {
          ...action.payload,
          Status: [...action.payload.Status]
        },
        isPending: false
      };
    case types.GET_OPTIONS_FILTERS_PENDING:
      return {
        ...state,
        filters: {
          ...action.payload,
          SortBy: [TNE_SORT_BY.PERIOD, TNE_SORT_BY.CHANGE]
        },
        isPending: true
      };
    default:
      return state;
  }
}
